import { render } from "./ProjectDate.vue?vue&type=template&id=457b54e4&scoped=true"
import script from "./ProjectDate.vue?vue&type=script&lang=js"
export * from "./ProjectDate.vue?vue&type=script&lang=js"

import "./ProjectDate.vue?vue&type=style&index=0&id=457b54e4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457b54e4"]])

export default __exports__